module.exports = __webpack_public_path__ + "img/hospitium-06.e8face3f.jpg";